export default __webpack_public_path__ + "static/Lucas-photo-de-profil-d639a3bdf570a3a242ebda39b0224644.jpg";